import { apiClient } from './client';
import type { TicketStatusDef, StatusCategory } from '../types';

export const ticketStatusesApi = {
  list: async () => {
    const res = await apiClient.get('/ticket-statuses');
    return res.data.data.statuses as TicketStatusDef[];
  },

  create: async (data: {
    label: string;
    category: StatusCategory;
    color?: string;
    sortOrder?: number;
    isDefault?: boolean;
    notifyCustomer?: boolean;
  }) => {
    const res = await apiClient.post('/ticket-statuses', data);
    return res.data.data.status as TicketStatusDef;
  },

  update: async (id: string, data: Partial<Omit<TicketStatusDef, 'id' | 'companyId' | 'key'>>) => {
    const res = await apiClient.put(`/ticket-statuses/${id}`, data);
    return res.data.data.status as TicketStatusDef;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/ticket-statuses/${id}`);
  },
};
